import { CaretDownIcon } from '@radix-ui/react-icons';
import { Button, DropdownMenu } from '@radix-ui/themes';
import { BugIcon, DogIcon, FishIcon, PersonIcon } from '@phosphor-icons/react';
import type { Icon } from '@phosphor-icons/react';
import { useTranslation, type MessageKey } from '../../../i18n';
import { useEditorStore } from '../../../stores/editorStore';
import { useMovieStore } from '../../../stores';
import { CHARACTER_PRESET_IDS, type CharacterPresetId } from '../../../util/characterPresets';

const PRESET_META: Record<CharacterPresetId, { titleKey: MessageKey; icon: Icon }> = {
  humanoid: { titleKey: 'toolbar.characterPresets.humanoid', icon: PersonIcon },
  animal: { titleKey: 'toolbar.characterPresets.animal', icon: DogIcon },
  turtle: { titleKey: 'toolbar.characterPresets.turtle', icon: BugIcon },
  octopus: { titleKey: 'toolbar.characterPresets.octopus', icon: FishIcon },
};

/**
 * Preset karakter ekleme menüsü. Seçim, Stage'in sahneye yazacağı bir
 * istek olarak store'a düşer; karakter sahne ortasına group olarak gelir.
 */
export function CharacterTools() {
  const { t } = useTranslation();
  const requestCharacterInsert = useEditorStore((s) => s.requestCharacterInsert);
  const currentScene = useMovieStore((s) => s.currentScene);

  return (
    <div className="character-tools">
      <DropdownMenu.Root>
        <DropdownMenu.Trigger>
          <Button
            variant="soft"
            radius="none"
            size="3"
            className="character-tools-trigger"
            aria-label={t('toolbar.characters')}
            disabled={!currentScene}
          >
            <PersonIcon aria-hidden="true" />
            <CaretDownIcon aria-hidden="true" className="character-tools-chevron" />
          </Button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content variant="soft" size="2" align="start" sideOffset={4}>
          {CHARACTER_PRESET_IDS.map((preset) => {
            const meta = PRESET_META[preset];
            const Icon = meta.icon;
            return (
              <DropdownMenu.Item key={preset} onSelect={() => requestCharacterInsert(preset)}>
                <Icon aria-hidden="true" />
                {t(meta.titleKey)}
              </DropdownMenu.Item>
            );
          })}
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </div>
  );
}
